import { filter } from 'rxjs/operators';
import { EditTemplateMarketingMenuViewModel } from '../edit-template-marketing-menu-view-model';
import { Injectable, Injector, NgZone } from '@angular/core';
import { TemplateDomainModel } from '../../../../../../domainModels/template-domain-model';
import { LocationDomainModel } from '../../../../../../domainModels/location-domain-model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EditDriveThruMenuViewModel } from '../../../../../menu/components/edit-menu/edit-marketing-menu/edit-drive-thru-menu/edit-drive-thru-menu-view-model';
import { WebSocketService } from '../../../../../../services/web-socket.service';
import { ToastService } from '../../../../../../modules/toasts/service/toast.service';

@Injectable()
export class EditTemplateMarketingDriveThruMenuViewModel extends EditTemplateMarketingMenuViewModel {
  constructor(
    protected override editMenuViewModel: EditDriveThruMenuViewModel,
    templateDomainModel: TemplateDomainModel,
    locationDomainModel: LocationDomainModel,
    toastService: ToastService,
    webSocketService: WebSocketService,
    ngZone: NgZone,
    ngbModal: NgbModal,
    injector: Injector
  ) {
    super(
      editMenuViewModel,
      templateDomainModel,
      locationDomainModel,
      toastService,
      webSocketService,
      ngZone,
      ngbModal,
      injector
    );
  }

  override listenForFetchMenuTemplateCommand(): void {
    this.reloadTemplateMessages$
      .pipe(filter(({ message, menuTemplate }) => message?.isAboutThis(menuTemplate)))
      .subscribeWhileAlive({
        owner: this,
        next: ({ message, menuTemplate, userId }) => {
          this.editMenuViewModel.handleReloadDriveThruMenuCommand(message, menuTemplate, userId);
        }
      });
  }
}
